export const getImage = (image: any, imageCache: Record<string, any>) => {
  if (!image) {
    return null;
  }

  if (image.asset._id in imageCache) {
    return imageCache[image.asset._id];
  }

  return image;
};
